import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useFetchDictionaryMarkdown = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ datasetCode }) => handler({
    type: actions.FETCH_DICTIONARY_MARKDOWN, category, code, datasetCode,
  }), [category, code]);
};

export default {
  useFetchDictionaryMarkdown,
};
